import React from "react";
import BooksNavbar from "../components/BooksNavbar";

const Adhd = () => {
  return (
    <div>
      <section
        className="relative min-h-screen bg-cover bg-center overflow-hidden"
        style={{ backgroundImage: "url('/water-colour-clouds.png')" }}
      >

        <BooksNavbar textColor="black" />

        <div className="relative z-10 min-h-screen pt-28 pb-16">

          {/* Page Title */}
          <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-16">

            <h2
              className="text-lg md:text-xl text-[#5f6f4f] mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              LEARN ABOUT THE SCIENCE
            </h2>

            <div className="flex items-center w-full max-w-sm mb-6 mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f] text-lg">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

            <h1
              className="text-4xl md:text-6xl text-black leading-tight mb-4"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Aging Successfully
            </h1>

            <p
              className="text-xl md:text-2xl italic text-[#5f6f4f] leading-snug mb-6"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              Your Brain Is Not a Car
            </p>

            <div className="flex items-center w-full max-w-sm mx-auto">
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
              <span className="px-4 text-[#8c8b5f]">❖</span>
              <div className="flex-1 h-[1px] bg-[#8c8b5f]"></div>
            </div>

          </div>

          {/* Content */}
          <div className="max-w-7xl mx-auto px-6 md:px-12">

            <div className="grid lg:grid-cols-2 gap-12 items-start">

              {/* Left Column */}
              <div className="max-w-2xl">

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  Most of us think about aging the wrong way. We imagine the brain as a machine:
                  use it for long enough and the parts gradually wear out. Memory fades.
                  Thinking slows. Confusion creeps in. Cognitive decline, we assume, is simply
                  the price we pay for growing older.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  But what if that's not true? What if aging is not a story of inevitable
                  decline, but a story of maintenance, adaptation, and resilience? After all,
                  we don't expect every seventy-year-old to think alike. Some struggle to
                  remember names or appointments. Others launch businesses, write books, run
                  marathons, learn new languages, or chair international organizations.
                </p>

                <p
                  className="text-base text-black leading-relaxed mb-6"
                  style={{ fontFamily: "Playfair Display, serif" }}
                >
                  The difference isn't luck alone. Increasingly, neuroscience is revealing that
                  how we age depends on a complex interplay of lifestyle, health, experience,
                  and the choices we make decades before any symptoms appear.
                </p>

              </div>

              {/* Right Image */}
              <div className="flex justify-center lg:justify-end">
                <img
                  src="/aging_successfully.png"
                  alt="Aging Successfully"
                  className="w-full max-w-[700px]"
                />
              </div>

            </div>

            {/* Full Width Text */}
            <div className="mt-2">
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In 2024, my team conducted one of the largest studies ever to examine the
                relationship between lifestyle choices and executive function as we age. The
                encouraging news is that exercise helps, good sleep helps, staying mentally
                engaged helps, and maintaining strong social connections helps.
              </p>
              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Even activities we don't traditionally associate with brain health—like
                learning new skills, playing certain types of games, or challenging ourselves
                intellectually—may contribute to keeping our executive functions sharp as we
                grow older.
              </p>

              <p
                className="text-base text-black leading-relaxed mb-6"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                In <em>Think Before You Think</em>, you'll discover why cognitive decline is
                not an unavoidable consequence of aging, how executive function shapes our
                ability to remain independent and engaged, and why measuring brain health may
                one day become as routine as checking our blood pressure.
              </p>

              <p
                className="text-base text-black leading-relaxed"
                style={{ fontFamily: "Playfair Display, serif" }}
              >
                Because successful aging isn't about adding years to your life. It's about
                adding life to your years.
              </p>

              {/* Creyos Test Button */}
              <div className="mt-12 text-center">
                <a
                  href="https://habstudy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#D4AF37] text-black px-4 py-2 font-semibold"
                >
                  IF YOU'D LIKE TO TRY SOME OF THE TESTS BEHIND THE SCIENCE, CLICK HERE
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Adhd;